import { Box, CircleButton, TextField, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Title } from '@/components/UI';
import { usePartnerData } from '@/providers/PartnerData.provider';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import styles from './ApplicationPendingState.module.scss';
import PendingActionsIcon from './pending_actions.svg';

const cn = withStyles(styles);

type Props = {
  onBoardingLink: string | null;
  hasValidOnboardingUrl: boolean | null;
  onCopy: () => void;
  onSendEmail: () => void;
};

export default function ApplicationPendingState({ onBoardingLink, hasValidOnboardingUrl, onCopy, onSendEmail }: Props) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.Account.ApplicationPending' });

  const {
    response: { isRoleViewOnly },
  } = usePartnerData();

  const { canSendOnboardingEmail } = useModuleFeatureFlag('accounts');

  return (
    <Box flx="col" ai="center" jc="center" gapSize="24px" className={cn('container')}>
      <img src={PendingActionsIcon} className={cn('icon')} alt="" />

      <Box flx="col" ai="center" gapSize="8px">
        <Title level="4">{t('title', { defaultValue: 'Account activation pending' })}</Title>

        <p className={cn('description')}>
          {t('description', {
            defaultValue: 'The customer needs to complete their onboarding first. Share the link below to get started.',
          })}
        </p>
      </Box>

      <div className={cn('linkContainer')}>
        <TextField
          inputClass={cn('readonlyInput')}
          name="onboardingUrl"
          readOnly
          variant="outlineShadow"
          value={onBoardingLink || ''}
        />

        <div className={cn('actions')}>
          <CircleButton
            colorScheme="action"
            icon="content_copy"
            onClick={onCopy}
            disabled={!hasValidOnboardingUrl || isRoleViewOnly}
          />

          {canSendOnboardingEmail && (
            <CircleButton
              colorScheme="action"
              icon="send"
              data-testid="applicationPending-sendOnboardingEmail"
              onClick={onSendEmail}
              disabled={!hasValidOnboardingUrl || isRoleViewOnly}
            />
          )}
        </div>
      </div>
    </Box>
  );
}
